import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

export const blogListApi = catchAsync(async (currentPage) => {  
    const data = await httpsCall.get(`blog/blog-list/${currentPage}/6`);
    return data;
});

export const blogDetailsApi = catchAsync(async (blogId) => {  
    const data = await httpsCall.get(`blog/blog-detail/${blogId}`);
    return data;
});